export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    BUCKET: 'bestmediafiles'
  },
  apiGateway: {
    URL: 'https://ga9ym2wjab.execute-api.us-east-1.amazonaws.com/p',
    REGION: 'us-east-1'
  },
  cognito: {
    REGION: 'us-east-1',
    IDENTITY_POOL_ID: 'us-east-1:8d5a0026-2b0f-4c4f-9b11-5ece0984be53',
    USER_POOL_ID : 'us-east-1_PqRT8ivRB',
    APP_CLIENT_ID : '16b0vjutcqthi5harpfogog5qm'
  }
};



// WEBPACK FOOTER //
// ./src/config.js